// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rW7Ft","location":"Header_location__2ssbl"};